import { Box } from "@chakra-ui/react";
import { useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaButton, RanaModal } from "@nens/ranalib";

import { usePublicationStore } from "../../../store/store";
import { Layer } from "../../../types/publication";

type RemoveStudyAreaDialogProps = {
  close: () => void;
  layer: Layer;
};

export function RemoveStudyAreaDialog({ layer, close }: RemoveStudyAreaDialogProps) {
  const intl = useIntl();
  const removeStudyAreaFromCurrentMap = usePublicationStore(
    (state) => state.removeStudyAreaFromCurrentMap
  );
  const handleRemove = useCallback(() => {
    removeStudyAreaFromCurrentMap();
    close();
  }, [close, removeStudyAreaFromCurrentMap]);

  return (
    <RanaModal
      isOpen
      onClose={close}
      topBar={intl.formatMessage({
        id: "publication.map.removestudyareamodal.title",
        defaultMessage: "Remove study area",
      })}
      buttons={[
        <RanaButton key="cancel" variant="secondary" onClick={close}>
          <FormattedMessage id="publication.layer.button.cancel" defaultMessage="Cancel" />
        </RanaButton>,
        <RanaButton key="remove" variant="danger" onClick={handleRemove}>
          <FormattedMessage
            id="publication.study_area.button.remove_study_area"
            defaultMessage="Remove study area"
          />
        </RanaButton>,
      ]}
    >
      <Box p={1}>
        <FormattedMessage
          id="publication.study_area.removestudyareamodal.message"
          defaultMessage='Are you sure you want to remove the study area "{name}"?'
          values={{ name: layer.name }}
        />
      </Box>
    </RanaModal>
  );
}
